export default "__VITE_ASSET__CF9xYDZK__"